import { Injectable } from '@angular/core';
import { SynchronizationInterface } from '@evorait/pace-core';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SynchronizationService implements SynchronizationInterface {
    public sendOfflineDataAndReceiveNotificationsAndBootStock(): Observable<void> {
        throw new Error(
            `Method sendOfflineDataAndReceiveNotificationsAndBootStock shouldn't be triggered for pace forms for fi. method defined to follow the interface`,
        );
    }
    public flushCompletely(): Observable<boolean> {
        throw new Error(
            `Method flushCompletely shouldn't be triggered for pace forms for fi. method defined to follow the interface`,
        );
    }
    public receiveNotifications(triggerSyncEvent = true): Observable<void> {
        throw new Error(
            `Method receiveNotifications shouldn't be triggered for pace forms for fi. method defined to follow the interface and parameter ${triggerSyncEvent}`,
        );
    }
    public receiveWhatsNew(): Observable<void> {
        return of(undefined);
    }

    public sendOfflineData(): Observable<void> {
        return of(undefined);
    }

    public receiveEverything(): Observable<void> {
        return of(undefined);
    }

    public receiveEverythingCacheFirst(): Observable<void> {
        return of(undefined);
    }
}
